import s from "../../../../../@babel_runtime@7.25.6/node_modules/@babel/runtime/helpers/esm/extends.js";
import { routeProps as n, route as e } from "../utils/router.js";
import { ChildrenMixin as r } from "../mixins/relation.js";
import a from "../button/index.js";
import { createNamespace as c } from "../utils/create/index.js";
var o = c("goods-action-button"),
  h = o[0],
  p = o[1];
var g = h({
  mixins: [r("vanGoodsAction")],
  props: s({}, n, {
    type: String,
    text: String,
    icon: String,
    color: String,
    loading: Boolean,
    disabled: Boolean
  }),
  computed: {
    isFirst: function isFirst() {
      var t = this.parent && this.parent.children[this.index - 1];
      return !t || t.$options.name !== this.$options.name;
    },
    isLast: function isLast() {
      var t = this.parent && this.parent.children[this.index + 1];
      return !t || t.$options.name !== this.$options.name;
    }
  },
  methods: {
    onClick: function onClick(t) {
      this.$emit("click", t), e(this.$router, this);
    }
  },
  render: function render() {
    var t = arguments[0];
    return t(a, {
      class: p([{
        first: this.isFirst,
        last: this.isLast
      }, this.type]),
      attrs: {
        size: "large",
        type: this.type,
        icon: this.icon,
        color: this.color,
        loading: this.loading,
        disabled: this.disabled
      },
      on: {
        click: this.onClick
      }
    }, [this.slots() || this.text]);
  }
});
export { g as default };
